/** A grass block, for Minecraft hosting. */
export function GrassBlockIcon({ size = 32, className }: { size?: number; className?: string }) {
  return <img src="/games/minecraft-grass-block.png" width={size} height={size} className={className} alt="" aria-hidden draggable={false} />;
}
